import React, { useState } from "react";
import { useAuth, API_URL } from "../AuthContext";
import { SPECIALTIES } from "../SpecialtyContext";

export default function Register({ onClose, onSwitchToLogin, onFeedback, onSuccess }) {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", display_name: "", password: "", confirm: "", specialty: "" });
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = field => e => setForm(prev => ({ ...prev, [field]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError("Пароли не совпадают"); return; }
    if (form.password.length < 6) { setError("Пароль должен быть не менее 6 символов"); return; }
    if (!consent) { setError("Необходимо согласие на обработку персональных данных"); return; }
    setLoading(true);
    setError("");
    try {
      const r = await fetch(`${API_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email, display_name: form.display_name, password: form.password,
          specialty: form.specialty || null,
          pdn_consent: consent,
        }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || "Ошибка регистрации");
      login(data.access_token, data.user);
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Регистрация</h2>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>

        <div style={{ background: "#e6f6f7", color: "#007c84", borderRadius: 8, padding: "8px 12px", fontSize: "0.82rem", marginBottom: 12, textAlign: "center" }}>
          Портал в режиме бета-тестирования — если что-то работает не так, пожалуйста,{" "}
          <button type="button" onClick={onFeedback} style={{ background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", textDecoration: "underline", cursor: "pointer" }}>сообщите нам об этом</button>
        </div>

        <form onSubmit={submit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}
          <label>Имя / ФИО</label>
          <input type="text" value={form.display_name} onChange={set("display_name")}
            placeholder="Иванов Д.А." required className="auth-input" />
          <label>Email</label>
          <input type="email" value={form.email} onChange={set("email")}
            placeholder="doctor@mail.ru" required className="auth-input" />
          <div style={{ fontSize: "0.8rem", color: "#888", marginTop: -6 }}>
            На эту почту придёт ссылка для подтверждения — без неё можно читать портал,
            но нельзя писать в чат
          </div>
          <label>Пароль</label>
          <input type="password" value={form.password} onChange={set("password")}
            placeholder="Не менее 6 символов" required className="auth-input" />
          <label>Повторите пароль</label>
          <input type="password" value={form.confirm} onChange={set("confirm")}
            placeholder="••••••••" required className="auth-input" />
          <label>Специальность <span style={{ fontWeight: 400, color: "#888" }}>(можно указать позже в профиле)</span></label>
          <select className="auth-input" value={form.specialty} onChange={set("specialty")}>
            <option value="">Не выбрана</option>
            {SPECIALTIES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
          </select>

          <label style={{ display: "flex", alignItems: "flex-start", gap: 8, cursor: "pointer", fontWeight: 400 }}>
            <input
              type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)}
              required style={{ width: 16, height: 16, marginTop: 3, flexShrink: 0 }}
            />
            <span style={{ fontSize: "0.85rem", color: "#444", fontWeight: 400 }}>
              Я согласен(на) с{" "}
              <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#007c84" }}>
                Политикой обработки персональных данных
              </a>{" "}
              и{" "}
              <a href="/terms" target="_blank" rel="noopener noreferrer" style={{ color: "#007c84" }}>
                Пользовательским соглашением
              </a>
            </span>
          </label>

          <button type="submit" disabled={loading || !consent} className="auth-submit-btn">
            {loading ? "Регистрируем…" : "Зарегистрироваться"}
          </button>
        </form>
        <p className="auth-switch-text">
          Уже есть аккаунт?{" "}
          <button className="btn-link" onClick={onSwitchToLogin}>Войти</button>
        </p>
      </div>
    </div>
  );
}
